import { ReactNode } from "react";

import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";

type Props = {
    children: ReactNode;
};

export const RootCategory = ({ children }: Props) => {
    const { assortimentOpen } = useSidebarContext();

    if (!assortimentOpen) return null;

    return children;
};
